import React, { useState, useEffect, useRef } from 'react';
import './Technology.css';
// Footer component
import Footer from './Footer';

// --- DATA: TECHNOLOGIES (Left/Right Interface) ---
const techData = [
  {
    id: 1,
    title: "Robotic Spinal Decompression",
    image: "/tech1.jpg",
    description: "The RSD 4D system is a true non-surgical 3D spinal decompression treatment specifically developed to provide relief of pain and other symptoms associated with spinal disc conditions.",
    howItWorks: "The computer-controlled system gently and precisely decompresses the spine in three dimensions, creating targeted space between vertebrae. This reduces nerve compression, improves disc hydration, and provides effective relief without surgery.",
    worksBestFor: ["Herniated discs", "Bulging discs", "Degenerative disc disease", "Protruding discs", "Cervical & lumbar spine conditions"]
  },
  {
    id: 2,
    title: "Emteslla Chair",
    image: "/Emteslla.jpg",
    description: "The Emteslla Chair causes deep pelvic floor muscle stimulation and restoration of neuromuscular control through focused electromagnetic energy—performed while sitting comfortably and fully clothed.",
    howItWorks: "A single Emteslla session delivers thousands of supramaximal pelvic floor muscle contractions, which are extremely important for muscle re-education. These contractions are far beyond what voluntary exercises can achieve, restoring strength and neuromuscular control.",
    worksBestFor: ["Post-childbirth muscle re-education", "Post-prostate surgery recovery", "Post-menopausal women", "Stress urinary incontinence", "Urge urinary incontinence", "Erectile Dysfunction", "Uterine prolapse"] 
  },
  {
    id: 3,
    title: "Shockwave Therapy",
    image: "/tech3.png",
    description: "Shockwave Therapy dissolves calcified fibroblasts and initiates subsequent biochemical decalcification, providing effective non-invasive relief for chronic calcification-related conditions.",
    howItWorks: "High-energy acoustic waves target calcified fibroblasts, breaking them down and triggering the body’s biochemical decalcification process. This stimulates blood flow, activates the healing response, and restarts repair in long-standing injuries.",
    worksBestFor: ["Heel spur", "Calcification of shoulder", "Tennis elbow & golfer’s elbow", "Trapezitis", "Jumper’s knee"]
  },
  {
    id: 4,
    title: "TECAR Therapy",
    image: "/tech4.jpeg",
    description: "TECAR (Transfer of Energy Capacitive and Resistive) therapy reduces activity-induced spasms and contractions, improves blood flow, and helps muscle oxygenation to bring powerful therapeutic effects.",
    howItWorks: "By transferring energy through capacitive and resistive modes, TECAR generates deep therapeutic warmth within tissues. This improves blood flow and muscle oxygenation at a cellular level, delivering intensive pain relief, muscle relaxation, and oedema reduction while supporting tissue regeneration and healing.",
    worksBestFor: ["Intensive pain relief", "Muscle spasms & contractions", "Oedema reduction", "Tissue regeneration & healing"]
  },
  {
    id: 5,
    title: "Functional Magnetic Stimulation",
    image: "/tech5.jpeg",
    description: "FMS is an advanced therapy helpful for fracture healing, myorelaxation, myostimulation, and restoring nerve function—without needles or direct skin contact.",
    howItWorks: "FMS delivers focused magnetic pulses that stimulate nerves and muscles, promoting fracture healing, myorelaxation, and myostimulation. It restores nerve function, aids joint mobilization, and supports recovery after stroke by reducing spasticity and enabling muscle re-education and endurance.",
    worksBestFor: ["Fracture healing", "Nerve function restoration", "Post-stroke recovery", "Spasticity reduction", "Joint mobilization", "Muscle re-education & endurance"]
  },
  {
    id: 6,
    title: "Laser Therapy",
    image: "/tech6.jpg",
    description: "High-power Laser Therapy heals tissue while providing powerful pain management. Its extreme penetration depth and wavelength-specific mechanism deliver immediate relief.",
    howItWorks: "High power allows extreme penetration of light deep into tissues, stimulating cellular repair and improving circulation. The wavelength-specific photomechanic effect stimulates free nerve endings, blocking pain pathways in the nervous system and bringing immediate pain relief.",
    worksBestFor: ["Deep tissue healing", "Immediate pain relief", "Nerve pain management", "Pain pathway blocking"]
  },
  {
    id: 7,
    title: "Pulsed Electromagnetic Field Therapy (PEMF)",
    image: "/tech7.jpeg",
    description: "Pulsed Electromagnetic Field therapy enhances circulation and hydration while providing anti-inflammatory and bone healing benefits at a cellular level.",
    howItWorks: "Low-frequency electromagnetic pulses improve cellular function, enhance circulation and tissue hydration. PEMF has anti-inflammatory properties and supports bone healing and remodelling, making it effective for a range of chronic conditions.",
    worksBestFor: ["Diabetic neuropathy (tingling & numbness)", "Osteoporosis & fracture healing", "Osteoarthritis", "Chronic pain"]
  },
  {
    id: 8,
    title: "Lymphoedema Therapy System",
    image: "/tech8.jpeg",
    description: "The Lymphoedema Therapy System uses intermittent compression on peripheral parts showing venous circulatory disturbances, reducing risk of infection and aiding in swelling reduction.",
    howItWorks: "Gentle, sequential intermittent compression helps move excess fluid back into circulation, improving venous return and reducing swelling, discomfort, and heaviness while lowering infection risk and improving tissue health.",
    worksBestFor: ["Post-cancer surgery swelling", "Elephantiasis", "Restless leg syndrome", "Venous circulatory disturbances"]
  },
  {
    id: 9,
    title: "Conventional Physiotherapy Modalities",
    image: "/tech9.jpeg",
    description: "These are proven, foundational physiotherapy treatments used to support pain relief, muscle activation, and early-stage recovery.",
    howItWorks: "TENS & IFT: Reduce pain and improve blood flow. Ultrasound: Promotes deep tissue healing. EMS: Activates muscles and prevents muscle wasting.",
    worksBestFor: ["Pain relief", "Muscle activation", "Circulation", "Supportive rehabilitation"]
  }
];

// --- DATA: THERAPIES (Infinite Scroll) ---
const therapyData = [
  { id: 1, image: "/ther1.png" },
  { id: 2, image: "/ther2.png" },
  { id: 3, image: "/ther3.png" },
  { id: 4, image: "/ther4.png" },
  { id: 5, image: "/ther5.png" },
  { id: 6, image: "/ther6.png" },
  { id: 7, image: "/ther7.png" },
  { id: 8, image: "/ther8.png" },
  { id: 9, image: "/ther9.png" },
  { id: 10, image: "/ther10.png" },
  { id: 11, image: "/ther11.png" },
  { id: 12, image: "/ther12.png" },
  { id: 13, image: "/ther13.png" },
  { id: 14, image: "/ther14.png" },
  { id: 15, image: "/ther15.png" },
  { id: 16, image: "/ther16.png" },
  { id: 17, image: "/ther17.png" },
  { id: 18, image: "/ther18.png" },
];

const Technology = () => {
  const [activeTech, setActiveTech] = useState(techData[0]);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isFlipped, setIsFlipped] = useState(false); // Controls the flip state

  // --- SCROLL LOGIC REFS ---
  const trackRef = useRef(null);
  const animationRef = useRef(null);
  const scrollPos = useRef(0);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const startScrollLeft = useRef(0);
  const isHovered = useRef(false);

  // --- 1. INITIAL SETUP & CLEANUP ---
  useEffect(() => {
    window.scrollTo(0, 0);
    startAnimation();
    return () => {
      stopAnimation();
      // Determine cleanup for window listeners if component unmounts mid-drag
      window.removeEventListener('mousemove', handleWindowMouseMove);
      window.removeEventListener('mouseup', handleWindowMouseUp);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // --- 2. AUTO-ROTATION LOGIC (5 Seconds) ---
  useEffect(() => {
    // PAUSE if user is reading details (Flipped)
    if (isFlipped) return;

    const interval = setInterval(() => {
      // Find current index
      const currentIndex = techData.findIndex(t => t.id === activeTech.id);
      const nextIndex = (currentIndex + 1) % techData.length;

      // Trigger switch directly for auto-rotation
      if (activeTech.id !== techData[nextIndex].id) {
        setIsAnimating(true);
        setIsFlipped(false);
        setTimeout(() => {
          setActiveTech(techData[nextIndex]);
          setIsAnimating(false);
        }, 200);
      }
    }, 5000); // 5 seconds (Changed from 2000 to 5000 as per common UX, revert if 2s was intentional)

    return () => clearInterval(interval);
  }, [activeTech, isFlipped]); // Reset timer on activeTech change OR flip state change

  // --- 3. CLICK HANDLER (Replaces Hover) ---
  const handleTechClick = (tech) => {
    if (activeTech.id !== tech.id) {
      setIsAnimating(true);
      setIsFlipped(false); // Reset flip when changing items
      setTimeout(() => {
        setActiveTech(tech);
        setIsAnimating(false);
      }, 200);
    }
  };

  // --- ANIMATION LOOP ---
  const startAnimation = () => {
    if (animationRef.current) return;

    const animate = () => {
      // Pause auto-scroll if dragging OR hovering
      if (!isDragging.current && !isHovered.current) {
        scrollPos.current += 1;
        updatePosition();
      }
      animationRef.current = requestAnimationFrame(animate);
    };
    animationRef.current = requestAnimationFrame(animate);
  };

  const stopAnimation = () => {
    if (animationRef.current) {
      cancelAnimationFrame(animationRef.current);
      animationRef.current = null;
    }
  };

  const updatePosition = () => {
    if (!trackRef.current) return;
    const maxScroll = trackRef.current.scrollWidth / 2;
    // Infinite loop wrap-around logic
    if (scrollPos.current >= maxScroll) {
      scrollPos.current = 0;
    } else if (scrollPos.current < 0) {
      scrollPos.current = maxScroll;
    }
    trackRef.current.style.transform = `translate3d(${-scrollPos.current}px, 0, 0)`;
  };

  // --- MOUSE EVENTS (GLOBAL DRAG) ---
  // Defined here to capture current refs safely
  const handleWindowMouseMove = (e) => {
    if (!isDragging.current) return;
    e.preventDefault();
    const x = e.pageX;
    const walk = (x - startX.current) * 1.5; // 1.5x speed multiplier
    scrollPos.current = startScrollLeft.current - walk;
    updatePosition();
  };

  const handleWindowMouseUp = () => {
    isDragging.current = false;
    if (trackRef.current) trackRef.current.style.cursor = 'grab';

    // Cleanup listeners
    window.removeEventListener('mousemove', handleWindowMouseMove);
    window.removeEventListener('mouseup', handleWindowMouseUp);
  };

  const handleMouseDown = (e) => {
    isDragging.current = true;
    startX.current = e.pageX;
    startScrollLeft.current = scrollPos.current;
    if (trackRef.current) trackRef.current.style.cursor = 'grabbing';

    // Attach global listeners
    window.addEventListener('mousemove', handleWindowMouseMove);
    window.addEventListener('mouseup', handleWindowMouseUp);
  };

  const handleMouseEnter = () => { isHovered.current = true; };
  const handleMouseLeave = () => {
    isHovered.current = false;
    // Do NOT stop dragging here; let window.mouseup handle it
  };

  return (
    <div className="technology-container">

      {/* --- 1. PAGE INTRO --- */}
      <div className="tech-page-intro">
        <h1 className="tech-main-title">Advanced <span className="highlight-text">Modalities</span></h1>
        <div className="tech-intro-text-box">
          <p>
            At our clinic, we take pride in our commitment to providing a comprehensive range of
            <b> advanced physiotherapy modalities</b>, ensuring our patients receive cutting-edge
            treatments for their diverse healthcare needs. Here’s an in-depth look at some of
            the <span className="text-cyan">specialized therapies</span> we offer:
          </p>
        </div>
      </div>

      {/* --- 2. TECH INTERFACE --- */}
      <div className="tech-interface-wrapper">

        {/* LEFT SIDE: FLIP MONITOR */}
        <div className="tech-viewport-section">

          {/* 3D Scene Container */}
          <div className="flip-card-scene">
            <div className={`flip-card-inner ${isFlipped ? 'flipped' : ''}`}>

              {/* === FRONT FACE (Image + Intro) === */}
              <div className="flip-card-front">

                {/* Image Layer */}
                <div className={`viewport-image-container ${isAnimating ? 'glitch-active' : ''}`}>
                  <img src={activeTech.image} alt={activeTech.title} className="viewport-img" />
                  <div className="viewport-overlay"></div>
                </div>

                {/* Front Info */}
                <div className="viewport-info-front">
                  <h2 className="viewport-title">{activeTech.title}</h2>
                  <p className="viewport-desc">{activeTech.description}</p>
                  <button className="btn-learn-more" onClick={() => setIsFlipped(true)}>
                    Learn More
                  </button>
                </div>
              </div>

              {/* === BACK FACE (Details) === */}
              <div className="flip-card-back">
                <button className="btn-close-details" onClick={() => setIsFlipped(false)}>
                  &times;
                </button>

                <div className="back-content-wrapper">
                  <h2 className="viewport-title back-title">{activeTech.title}</h2>
                  <div className="back-scroll-area">
                    <p className="back-main-desc">{activeTech.description}</p>

                    <div className="extended-content">
                      <h3>How It Works</h3>
                      <p>
                        {activeTech.howItWorks}
                      </p>
                      <h3>Works Best For</h3>
                      <ul>
                        {activeTech.worksBestFor && activeTech.worksBestFor.map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* RIGHT SIDE: LIST */}
        <div className="tech-list-section">
          <div className="list-header"></div>
          <div className="tech-scroll-container">
            <div className="tech-nodes-list">
              {techData.map((item, index) => (
                <div
                  key={item.id}
                  className={`tech-node-item ${activeTech.id === item.id ? 'active' : ''}`}
                  onClick={() => handleTechClick(item)}
                >
                  <div className="node-index">
                    {index + 1 < 10 ? `0${index + 1}` : index + 1}
                  </div>
                  <div className="node-content">
                    <h3 className="node-title">{item.title}</h3>
                  </div>
                  <div className="node-status-light"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* --- 3. THERAPY SECTION --- */}
      <div className="section-therapy">
        <div className="therapy-header">
          <h2>Specialized <span className="highlight-text">Therapies</span></h2>
          <p>Beyond our technology, we offer hands-on specialized care programs.</p>
        </div>

        <div className="marquee-wrapper">
          <div
            className="marquee-track"
            ref={trackRef}
            onMouseDown={handleMouseDown}
            /* onMouseMove and onMouseUp removed - handled by window listeners */
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            {/* First Set */}
            {therapyData.map((item) => (
              <div className="therapy-card" key={`a-${item.id}`}>
                <img src={item.image} alt="Therapy" />
              </div>
            ))}
            {/* Duplicate Set */}
            {therapyData.map((item) => (
              <div className="therapy-card" key={`b-${item.id}`}>
                <img src={item.image} alt="Therapy" />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* =========================================
            ADDED FOOTER (Same as other pages)
      ========================================= */}
      <Footer />

    </div>
  );
};

export default Technology;